module.exports = __webpack_public_path__ + "static/media/loader.min.e084ca79.svg";